import { InviteUserToMeetingComponent } from "./invite-user-to-meeting.component";
export const InviteUserToMeetingModule = angular
    .module('inviteUserToMeeting', [])
    .component(InviteUserToMeetingComponent.selector, InviteUserToMeetingComponent.component)
    .name;
//# sourceMappingURL=invite-user-to-meeting.module.js.map